import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import { renderAutoCompleteSingleSelect, renderDateField, renderTimePicker, renderCheckBox, renderTextField, isFloat } from '../../../../components/reduxFields';
import Loader from '../../../../img/loader.gif';
import { required } from '../../../../components/validations';
import GooglePlaceAutocomplete from '../../../../components/GooglePlaceAutocomplete';
import history from '../../../../history';

const validate = (values) => {
  const errors = {};
  if (!values.location) {
    errors.location = 'Please select location.';
  }  
  if (!values.StartTime) {
    errors.StartTime = 'Please select start time.';
  }  
  if (!values.EndTime) {
    errors.EndTime = 'Please select end time.';
  }  
  if (values.EndTime <= values.StartTime) {
    errors.EndTime = 'End time should be greater than start time.';
  }    
  return errors;
};


class SmartSchedulingReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,
      FromDate: new Date().setDate(new Date().getDate() - 7),
      ToDate: new Date(),
      StartTime: new Date(),
      EndTime: new Date(),      
      // iframeURL: `${REPORT_URL}?%2fHC.SqlReports%2fSmartSchedulingReport&rs:Command=Render&rs:embed=true&OrganizationID=` + this.props.orgID + '&LocationID=' + this.props.locationID,
      iframeURL: '',
      isLoading: false,
      random: 0,
      Weekdays: [],
      latitude: 0.0,
      longitude: 0.0,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);
    this.handleDayChange = this.handleDayChange.bind(this);
    this.GetFullAddress = this.GetFullAddress.bind(this);
    this.IsFullAddressEmpty = this.IsFullAddressEmpty.bind(this);
  }

  GetFullAddress(componentForm) {
    this.setState({
      latitude: componentForm.lat,
      longitude: componentForm.lng,      
    })
  }

  IsFullAddressEmpty(searchText) {
    if (searchText.length === 0)
    {
      this.setState({
        latitude: 0.0,
        longitude: 0.0,      
      })
    }      
  }

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({
      [input.name]: value,
    });
  }

  handleDayChange=(e,obj) => {
    var days = this.state.Weekdays;
    var day = parseInt(obj.id);
    // var day = e.target.value;
    if(e.target.checked)
    {
      days.push(day);
    }
    else
    {
      var index = days.findIndex((value) => value === day);
      if (index >= 0) {
        days.splice(index, 1);
      }
    }   
    this.setState({ Weekdays: days });
  }

  appointmentFilterByDate = (formData) => {
    this.resetIframe();

    let FromDateFormat;
    let ToDateFormat;
    let StartTimeFormat;
    let EndTimeFormat;
    // console.log('formData.legth---', Object.keys(formData).length);
    if (Object.keys(formData).length) {
      FromDateFormat = moment(this.state.FromDate).format('YYYY-MM-DD');
      ToDateFormat = moment(this.state.ToDate).format('YYYY-MM-DD');

      StartTimeFormat = moment(this.state.StartTime).format('YYYY-MM-DDTHH:mm:ss');
      EndTimeFormat = moment(this.state.EndTime).format('YYYY-MM-DDTHH:mm:ss');
    } else {
      let DateFormat = new Date().setDate(new Date().getDate() - 7);
      FromDateFormat = moment(DateFormat).format('YYYY-MM-DD');
      let dateFormat = new Date();
      ToDateFormat = moment(dateFormat).format('YYYY-MM-DD');

      let startTime = new Date();
      StartTimeFormat = moment(startTime).format('YYYY-MM-DDTHH:mm:ss');
      let endTime = new Date();
      EndTimeFormat = moment(endTime).format('YYYY-MM-DDTHH:mm:ss');
    }
    let REPORT_URL  = GetReportUrl(this.props.agencyName);  
    // console.log('formData..................',formData, this.state.latitude, this.state.longitude)
    let reportName = base64Encode('CL_SmartScheduling_RPT');
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "LocationID","Value": "`+ (formData.location || 0) + `"},{"Name": "FromDate","Value": "`+ FromDateFormat + `"},{"Name": "ToDate","Value": "`+ ToDateFormat + `"},{"Name": "StartTime","Value": "`+ StartTimeFormat + `"},{"Name": "EndTime","Value": "`+ EndTimeFormat + `"},{"Name": "AvailablityDays","Value": "`+ (this.state.Weekdays && this.state.Weekdays.length > 0 ? this.state.Weekdays.toString() : 0) + `"},{"Name": "MinimumDailyHours","Value": "`+ (formData.MinimumDailyhours || 0.0) + `"},{"Name": "MinimumTotalHours","Value": "`+ (formData.MinimumTotalhours || 0.0) + `"},{"Name": "Latitude","Value": "`+ this.state.latitude + `"},{"Name": "Longitude","Value": "`+ this.state.longitude + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false});
  }

  resetIframe() {
    this.setState({random: this.state.random + 1});
  }
  
  renderReport() {
    return (
      <Iframe url={this.state.iframeURL}
        // width="450px"
        height="580px"
        id="myId"
        className="manual_report"
        display="initial"
        position="relative"
        onLoad={(e)=> this.onLoadReport(e)}
        key={this.state.random}
        allowFullScreen />
    );
  }

  handleChange = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }
  onBackClick = () => {
    history.push('/reports/scheduling-reports');
  }
  render() {
    const { handleSubmit } = this.props;    
    let weeks = [{ id: 1, value: 'Sun' }, { id: 2, value: 'Mon' }, { id: 3, value: 'Tue' }, { id: 4, value: 'Wed' }, { id: 5, value: 'Thu' }, { id: 6, value: 'Fri' }, { id: 7, value: 'Sat' }];
    //   let iframeUrl = `${REPORT_URL}?%2fHC.SqlReports%2fSmartSchedulingReport&rs:Command=Render&rs:embed=true&OrganizationID=` + this.state.organizationID + '&LocationID=' + this.state.locationID;
    // let windowsHeight = window.innerHeight + 159 + "px";
    // console.log(windowsHeight);
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Scheduling {' > '} Smart Scheduling Report</h2>
        :
          <h2 className="page_title">Smart Scheduling Report</h2>
        } 
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-4 mt-35 require">
                  <Field name="location"
                    label="Location"
                    handleNewRequest={this.handleChange}
                    options={this.props.userLocationList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-2">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />

                </div>
                <div className="col-sm-2">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    // minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
                <div className="col-sm-2">
                  <Field
                    name="StartTime"
                    placeholder="Start Time"
                    fullWidth={true}
                    component={renderTimePicker}
                    validate={[required]}       
                    selected={this.state.StartTime}            
                    onDateChange={this.onDateChange}
                  />
                </div>
                <div className="col-sm-2">
                    <Field
                    name="EndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    validate={[required]}
                    selected={this.state.EndTime}
                    onDateChange={this.onDateChange}
                    fullWidth={true}
                  />
                </div>
              </div>             
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Week(s)</h3>
                    <i className="flaticon flaticon-interface-1"></i>
                  </div>
                </div>                 
                  {
                    weeks.map((obj, i) => {
                      return (
                        <div className="col-sm-1 mt-20">
                        <Field key={i} name={obj.value} label={obj.value} onChange={(e)=>this.handleDayChange(e,obj)} component={renderCheckBox}/>
                          </div>
                      );
                    })
                  }                                      
              </div>
              <div className="row">
                <div className="col-sm-6">                   
                    <Field
                    name="MinimumDailyhours"                                                                                  
                    floatingLabelText="Minimum Daily hours"
                    maxLength="50"
                    normalize={isFloat}
                    component={renderTextField}/>                    
                </div>
                <div className="col-sm-6">
                    <Field
                    name="MinimumTotalhours"                                                                                  
                    floatingLabelText="Minimum Total hours"
                    maxLength="50"
                    normalize={isFloat}
                    component={renderTextField}/>                    
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">                   
                  <GooglePlaceAutocomplete
                    getFullAddress={this.GetFullAddress}
                    id="CustomAddress"
                    labelText="Service Address"
                    //errorText={isValidAddress ? '' : 'Invalid address. Please choose address from dropdown.'}
                    // hintText="Enter Address"                                       
                    IsFullAddress = {true}
                    isFullAddressEmpty={this.IsFullAddressEmpty}
                  />            
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        {this.renderReport()}
      </div>
    );
  }
}

SmartSchedulingReport = reduxForm({
  form: 'SmartSchedulingReportForm',
  validate,
  enableReinitialize: true,
})(SmartSchedulingReport);

function mapStateToProps(state) {
  let locationArr = [];
  if (state.login.userLocationList) {
    locationArr = (state.login.userLocationList).map((obj) => {
      return (
        {
          id: obj.id,
          value: obj.locationName,
        }
      );
    });
  }

  return {
    orgID: state.login.loginUserInfo.organizationID,
    userLocationList: locationArr,
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, {})(SmartSchedulingReport);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/SchedulingReports/SmartSchedulingReport.js